module.exports = __webpack_public_path__ + "img/Incorrect Band Width.89a1de7f.png";